<div class="header" [style.color]="titleColor">
    <i [className]="icon">{{iconBody}}</i> <span>{{title}}</span>
</div>
<mat-divider></mat-divider>